<template>
  <section class="postingan">
    <div style="margin: 5em 0; min-height: 100vh">
      <div class="container">
        <div class="card">
          <div class="card-body" style="padding: 5rem">
            <h1 style="margin-top: 0;" v-text="title"></h1>
            <p class="text-muted">
              <span v-text="new Date(created_at).toLocaleString()"></span>
            </p>
            <hr class="mb-4" />
            <div v-html="content"></div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import layout from '@/layout/Portal'
export default {
  layout,
  props: {
    title: String,
    created_at: String,
    content: String,
  },
}
</script>

<style lang="scss" scoped>
:deep(h1, h2, h3, h4, h5, h6) {
  margin-top: 2rem;
}
</style>
